module.exports = __webpack_public_path__ + "static/logo-flower-e380da8d3afcd28d2dcc7b89d7dcf0d8.png";